var map = {
	"./Academy.png": "0EJk",
	"./DEX.png": "iQ0r",
	"./charity.png": "Ukmr",
	"./ecosystem-banner.jpg": "RqWb",
	"./exchange.png": "MJbf",
	"./info.png": "Q/0H",
	"./labs.png": "oZ1a",
	"./launchpad.png": "INbZ",
	"./research.png": "T/6N",
	"./trust-wallet.png": "tpI6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xhxN";